import { useQuery } from '@tanstack/react-query';

import { getTenants } from '@/api/apiTenants';

export function useTenants(environmentId?: number) {
  return useQuery({
    queryKey: ['tenants', 'list', environmentId ?? 'all'],
    queryFn: () => getTenants(environmentId),
  });
}